import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Radio,
  Row,
  Select,
  Space,
  Switch,
  TimePicker,
  Upload,
  Divider,
  Transfer,
  App,
  Collapse,
  Typography,
} from 'antd';
import { DeleteOutlined, MenuOutlined, PlusOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import UploadEnterLink from './UploadEnterLink';
import CustomEditor from './custom-editor';
import { ClearIcon, IconArrowDown } from '../../assets/image/svg';
import UploadButton from '../UploadButton';
import UploadFileLink from '../UploadFileLink';

const { Text } = Typography;


const normFile = (e) => {
  return Array.isArray(e) ? e : e?.fileList;
};

// Removed uploadFileCDN as it was not directly used in SwitchInputType but referenced in commented code
// const uploadFileCDN = async ({ file, onSuccess, onError }) => {
//     if (file) {
//         await uploadImageCDN(file, (url) => {
//             onSuccess(url);
//         });
//     }
// };

const propsConfig = {
  upload: {
    valuePropName: 'fileList',
    getValueFromEvent: normFile,
  },
  checkbox: { valuePropName: 'checked' },
  switch: { valuePropName: 'checked' },
  'upload-cdn': { 
    valuePropName: 'fileList', 
    getValueFromEvent: normFile 
  },
};

const GroupForm = ({ form, itemGroup, name, parentName, modalWidth, firstName }) => {
  const onDragEnd = (result) => {
    try {
      if (!result.destination) return;

      const currentValues = form.getFieldsValue();

      if (Array.isArray(name)) {
        const targetGroup = currentValues[parentName][name[0]];
        if (!targetGroup) return;

        const reorderedItems = Array.from(targetGroup[name[1]]);
        const [movedItem] = reorderedItems.splice(result.source.index, 1);
        reorderedItems.splice(result.destination.index, 0, movedItem);

        const updatedGroup = {
          ...targetGroup,
          [name[1]]: reorderedItems,
        };

        form.setFieldsValue({
          [parentName]: {
            ...currentValues[parentName],
            [name[0]]: updatedGroup,
          },
        });
        return;
      }

      const targetGroup = currentValues[parentName];
      if (!targetGroup) return;

      const [movedItem] = targetGroup.splice(result.source.index, 1);
      targetGroup.splice(result.destination.index, 0, movedItem);

      form.setFieldsValue({ [parentName]: [...targetGroup] });
    } catch (err) {
      console.log(err.message);
    }
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId={`droppable-${Array.isArray(name) ? name.join('-') : name}`}>
        {(provided) => (
          <Form.List name={name}>
            {(fields, { add, remove }) => {
              return (
                <div
                  className={`w-full flex flex-col gap-4 items-center`}
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  {fields.map((field, index) => {
                    // Lấy tiêu đề hiển thị cho Collapse nếu cần
                    let headerTitle = `Mục ${index + 1}`;
                    if (itemGroup.isCollapse && itemGroup.headerField) {
                      const fieldValues = form.getFieldValue(name);
                      const currentItem = fieldValues?.[field.name];
                      if (currentItem?.[itemGroup.headerField]) {
                        headerTitle = currentItem[itemGroup.headerField];
                      }
                    }

                    return (
                      <Draggable key={field.key} draggableId={`${field.key}`} index={index}>
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            className={`${
                              itemGroup.classItem ?? 'flex items-center gap-1'
                            } bg-white rounded-lg p-2 border border-gray-200 shadow-sm`}
                            style={{
                              maxWidth: modalWidth,
                              width: '100%',
                              ...provided.draggableProps.style,
                            }}
                          >
                            <div className={itemGroup?.isSort === true ? 'min-w-6' : ''} {...provided.dragHandleProps}>
                              {itemGroup?.isSort === true && (
                                <MenuOutlined className={'p-1 h-6 cursor-pointer text-gray-400'} />
                              )}
                            </div>

                            <div className="flex-1 w-full overflow-hidden">
                              {itemGroup.isCollapse ? (
                                <Collapse ghost expandIconPosition="end" className="w-full custom-group-collapse">
                                  <Collapse.Panel
                                    header={
                                      <Text strong className="text-gray-700">
                                        {headerTitle}
                                      </Text>
                                    }
                                    key="1"
                                  >
                                    <Row
                                      className={`w-full ${
                                        itemGroup?.rowClass ?? 'border-t border-gray-100 pt-4 mt-2'
                                      }`}
                                    >
                                      {itemGroup?.filedsList.map((item, key) => {
                                        if (item.html || item.type === 'html') {
                                          return (
                                            <Col
                                              span={item.span || 24}
                                              md={item.md || item.span || 24}
                                              lg={item.lg || item.md || item.span || 24}
                                              key={key}
                                            >
                                              {item.content}
                                            </Col>
                                          );
                                        }
                                        item.rules =
                                          item.rules?.map((v) =>
                                            !v.message && v.required
                                              ? {
                                                  ...v,
                                                  message: `${
                                                    item.label || item.placeholder || item.labelHidden
                                                  } không được bỏ trống`,
                                                }
                                              : v
                                          ) || [];
                                        return typeof item.func === 'function' && !item.func(name, field.key) ? (
                                          ''
                                        ) : (
                                          <Col
                                            className={item.colClass || 'p-2'}
                                            key={key}
                                            span={item.span || 24}
                                            md={item.md || item.span || 24}
                                            lg={item.lg || item.md || item.span || 24}
                                          >
                                            {item.type === 'group' ? (
                                              <GroupForm
                                                itemGroup={item}
                                                name={[field.name, item.name]}
                                                form={form}
                                                parentName={name}
                                                modalWidth={modalWidth}
                                                firstName={firstName}
                                              />
                                            ) : item.type === 'upload-enter-link' ? (
                                              <UploadEnterLink
                                                nameForm={
                                                  Array.isArray(item.name)
                                                    ? [field.name, ...item.name]
                                                    : [field.name, item.name]
                                                }
                                                name={name}
                                                form={form}
                                                rules={item.rules}
                                                label={item.label || item.placeholder}
                                                propsInput={item.propsFormItem}
                                                item={item}
                                                firstName={firstName}
                                              />
                                            ) : (
                                              <Form.Item
                                                {...(propsConfig[item.type] || {})}
                                                name={
                                                  Array.isArray(item.name)
                                                    ? [field.name, ...item.name]
                                                    : [field.name, item.name]
                                                }
                                                rules={item.rules}
                                                label={item.label}
                                                className={item.className || ''}
                                                initialValue={item.defaultValue}
                                                {...(item.propsFormItem || {})}
                                              >
                                                <SwitchInputType item={item} />
                                              </Form.Item>
                                            )}
                                          </Col>
                                        );
                                      })}
                                    </Row>
                                  </Collapse.Panel>
                                </Collapse>
                              ) : (
                                <Row
                                  className={`w-full ${itemGroup?.rowClass ?? 'border border-gray-100 p-4 rounded-xl'}`}
                                >
                                  {itemGroup?.filedsList.map((item, key) => {
                                    if (item.html || item.type === 'html') {
                                      return (
                                        <Col
                                          span={item.span || 24}
                                          md={item.md || item.span || 24}
                                          lg={item.lg || item.md || item.span || 24}
                                          key={key}
                                        >
                                          {item.content}
                                        </Col>
                                      );
                                    }
                                    item.rules =
                                      item.rules?.map((v) =>
                                        !v.message && v.required
                                          ? {
                                              ...v,
                                              message: `${
                                                item.label || item.placeholder || item.labelHidden
                                              } không được bỏ trống`,
                                            }
                                          : v
                                      ) || [];
                                    return typeof item.func === 'function' && !item.func(name, field.key) ? (
                                      ''
                                    ) : (
                                      <Col
                                        className={item.colClass || 'p-2'}
                                        key={key}
                                        span={item.span || 24}
                                        md={item.md || item.span || 24}
                                        lg={item.lg || item.md || item.span || 24}
                                      >
                                        {item.type === 'group' ? (
                                          <GroupForm
                                            itemGroup={item}
                                            name={[field.name, item.name]}
                                            form={form}
                                            parentName={name}
                                            modalWidth={modalWidth}
                                            firstName={firstName}
                                          />
                                        ) : item.type === 'upload-enter-link' ? (
                                          <UploadEnterLink
                                            nameForm={
                                              Array.isArray(item.name)
                                                ? [field.name, ...item.name]
                                                : [field.name, item.name]
                                            }
                                            name={name}
                                            form={form}
                                            rules={item.rules}
                                            label={item.label || item.placeholder}
                                            propsInput={item.propsFormItem}
                                            item={item}
                                            firstName={firstName}
                                          />
                                        ) : (
                                          <Form.Item
                                            {...(propsConfig[item.type] || {})}
                                            name={
                                              Array.isArray(item.name)
                                                ? [field.name, ...item.name]
                                                : [field.name, item.name]
                                            }
                                            rules={item.rules}
                                            label={item.label}
                                            className={item.className || ''}
                                            initialValue={item.defaultValue}
                                            {...(item.propsFormItem || {})}
                                          >
                                            <SwitchInputType item={item} />
                                          </Form.Item>
                                        )}
                                      </Col>
                                    );
                                  })}
                                </Row>
                              )}
                            </div>

                            {(!itemGroup.minItem || itemGroup.minItem < fields.length) && (
                              <div className={'min-w-6 ml-2'}>
                                <Button
                                  type="primary"
                                  danger
                                  className={'p-1 h-8 w-8 rounded-lg flex items-center justify-center'}
                                  onClick={() => remove(field.name)}
                                  disabled={fields.length === 0}
                                >
                                  {itemGroup.titleButtonDelete || <DeleteOutlined />}
                                </Button>
                              </div>
                            )}
                          </div>
                        )}
                      </Draggable>
                    );
                  })}
                  {provided.placeholder}
                  {(!itemGroup.maxItem || itemGroup.maxItem > fields.length) && itemGroup.showButton !== false && (
                    <Button
                      onClick={() => {
                        const defaultValues = {};
                        if (Array.isArray(itemGroup?.filedsList)) {
                          itemGroup.filedsList.forEach((f) => {
                            if (f.name && f.defaultValue !== undefined) {
                              defaultValues[f.name] = f.defaultValue;
                            }
                          });
                        }
                        add(defaultValues);
                      }}
                      className="mb-2 w-full max-w-[200px] rounded-xl h-10 border-dashed"
                    >
                      <PlusOutlined />
                      {itemGroup.titleButtonAdd || 'Thêm mục mới'}
                    </Button>
                  )}
                </div>
              );
            }}
          </Form.List>
        )}
      </Droppable>
    </DragDropContext>
  );
};

GroupForm.propTypes = {
  form: PropTypes.object,
  itemGroup: PropTypes.object,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  parentName: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  modalWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  firstName: PropTypes.string,
};

const ensureCdnUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:')) {
    return url;
  }
  const baseDomain = 'https://cdn.lichviet.org';
  const path = url.startsWith('/') ? url : `/${url}`;
  return baseDomain + path;
};

// Ô dán link đi kèm nút upload là một field RIÊNG (`<tên field>__link`), không dùng chung
// giá trị với fileList — nhờ vậy người dùng có thể vừa chọn file vừa dán link như CMS cũ.
// Lúc submit, CrudPage ưu tiên link (parity lichviet_cms) rồi xoá key phụ này khỏi payload.
export const UPLOAD_LINK_SUFFIX = '__link';
export const uploadLinkFieldName = (name) => `${name}${UPLOAD_LINK_SUFFIX}`;

const SwitchInputType = (props) => {
  const { item, onChange } = props;
  const value = props.value !== undefined ? props.value : props.fileList || props.checked;
  const { message } = App.useApp();
  return (
    <>
      {item.render && item.render({ item, value, onChange })}
      {(item.type === 'input' || !item.type) && !item.render && (
        <Input
          {...(item.propsInput || {})}
          value={value}
          onChange={onChange}
          placeholder={item.placeholder || 'Nhập ' + item.label?.toLowerCase()}
          allowClear={
            item.allowClear === undefined || item.allowClear
              ? {
                  clearIcon: <ClearIcon />,
                }
              : false
          }
        />
      )}
      {item.type === 'time' && (
        <TimePicker
          {...(item.propsInput || {})}
          value={value}
          onChange={onChange}
          needConfirm={false}
          format={item.format || 'HH:mm'}
        />
      )}
      {item.type === 'radio' && (
        <Radio.Group size="large" className={item.className} value={value} onChange={onChange}>
          <Space direction={item?.typeRadioType ?? 'vertical'} className="w-full">
            {item?.options &&
              item.options.map((child, index) => (
                <div key={index} style={{ width: '100%' }}>
                  <Radio value={child?.value} className="w-full">
                    {child?.label || child?.value}
                  </Radio>
                  {child?.isMore && (
                    <Form.Item name={`optionText-${child?.value}`} style={{ marginLeft: 24 }} noStyle>
                      <Input className="w-full" placeholder={child?.placeHolder} />
                    </Form.Item>
                  )}
                </div>
              ))}
          </Space>
        </Radio.Group>
      )}
      {item.type === 'date' && (
        <DatePicker
          needConfirm={false}
          className="w-full"
          value={value}
          onChange={onChange}
          format={item.format || 'DD/MM/YYYY'}
          placeholder={'Nhập ' + item.label?.toLowerCase()}
          {...(item.propsInput || {})}
        />
      )}
      {item.type === 'select' && (
        <Select
          optionFilterProp={item.optionFilterProp ?? 'label'}
          placeholder={item.placeholder || 'Chọn ' + item.label?.toLowerCase()}
          suffixIcon={<IconArrowDown />}
          options={item.options}
          {...(item.propsInput || {})}
          value={value}
          onChange={onChange}
          onSearch={item.onSearch || item.propsInput?.onSearch}
        />
      )}

      {item.type === 'textarea' && (
        <Input.TextArea
          rows={item.rows || 4}
          autoSize={item.autoSize !== undefined ? item.autoSize : { minRows: 4 }}
          value={value}
          onChange={onChange}
          placeholder={item?.placeholder || 'Nhập ' + item.label?.toLowerCase()}
          rootClassName="py-2 text-base"
        />
      )}
      {item.type === 'number' && (
        <InputNumber
          min={item.min || 0}
          className="w-full"
          value={value}
          onChange={onChange}
          placeholder={'Nhập ' + (item.placeholder || item.label?.toLowerCase())}
          {...(item.propsInput || {})}
          formatter={(value) => (value ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '')}
          parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
        />
      )}
      {item.type === 'range-picker' && (
        <DatePicker.RangePicker
          className="w-full"
          value={value}
          onChange={onChange}
          {...(item.propsInput || {})}
          placeholder={['Từ ngày', 'Đến ngày']}
        />
      )}
      {item.type === 'password' && (
        <Input.Password
          value={value}
          onChange={onChange}
          placeholder={'Nhập ' + item.label?.toLowerCase()}
          visibilityToggle
          {...(item.propsInput || {})}
        />
      )}
      {item.type === 'checkbox' && (
        <Checkbox checked={value} onChange={onChange} {...(item.propsInput || {})}>
          {item.labelCheckbox}
        </Checkbox>
      )}
      {(item.type === 'upload' || item.type === 'upload-cdn') && (
        <Upload
          maxCount={item.maxCount || 1}
          multiple={!!item.multiple}
          accept={item.accept || '*'}
          fileList={(Array.isArray(value) ? value : (typeof value === 'string' && value ? [{ uid: '-1', name: value.split('/').pop() || 'image', status: 'done', url: value, thumbUrl: value }] : [])).map((file) => {
            const newFile = { ...file };
            if (newFile.url) newFile.url = ensureCdnUrl(newFile.url);
            if (newFile.thumbUrl) newFile.thumbUrl = ensureCdnUrl(newFile.thumbUrl);
            if (!newFile.url && !newFile.thumbUrl && newFile.originFileObj && (newFile.originFileObj instanceof File || newFile.originFileObj instanceof Blob)) {
              try {
                newFile.thumbUrl = URL.createObjectURL(newFile.originFileObj);
              } catch (err) {
                console.error(err);
              }
            }
            return newFile;
          })}
          onChange={onChange}
          beforeUpload={(file) => {
            // Trước đây hardcode 5MB nên video / ảnh lớn bị chặn oan dù field khai báo maxSizeMB khác.
            const maxSizeMB = item.maxSizeMB || 50;
            if (file.size / 1024 / 1024 > maxSizeMB) {
              message.error(`Dung lượng file phải nhỏ hơn ${maxSizeMB}MB!`);
              return Upload.LIST_IGNORE;
            }
            return false;
          }}
          {...(item.propsInput || {})}
          listType="picture-card"
        >
          {item.icon !== undefined ? (
            item.icon
          ) : (
            <button type="button" className="border-0 bg-none">
              <PlusOutlined />
              <div className="mt-2 text-xs">Tải file</div>
            </button>
          )}
        </Upload>
      )}
      {item.type === 'ckeditor' && (
        <CustomEditor initialData={value || ''} onChange={onChange}>
          {item.icon !== undefined ? item.icon : null}
        </CustomEditor>
      )}
      {item.type === 'switch' && <Switch checked={value} onChange={onChange} {...(item.propsInput || {})} />}
      {item.type === 'transfer' && (
        <Transfer
          oneWay
          pagination
          {...(item.propsInput || {})}
          targetKeys={value}
          onChange={onChange}
          listStyle={{
            width: '100%',
            height: 350,
            borderRadius: '12px',
            ...item.propsInput?.listStyle,
          }}
        />
      )}
      {item.type === 'upload-button' && (
        <UploadButton
          value={value}
          onChange={onChange}
          multiple={!!item.multiple}
          maxCount={item.maxCount || 1}
          {...(item.propsInput || {})}
        />
      )}
      {item.type === 'upload-file' && (
        <UploadFileLink
          value={value}
          onChange={onChange}
          placeholder={item.placeholder}
          accept={item.accept || '*'}
          maxSizeMB={item.maxSizeMB}
          uploadFolder={item.uploadFolder || 'lichviet'}
          {...(item.propsInput || {})}
        />
      )}
      {item.labelAfter}
    </>
  );
};

SwitchInputType.propTypes = {
  item: PropTypes.object.isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func,
};

// Parity CMS cũ (lichviet_cms): mỗi ảnh có thêm 1 ô dán link nằm ngay dưới nút upload.
// Điền cả hai thì link thắng — nhắc luôn tại chỗ để người dùng không tưởng file mới được lưu.
const UploadLinkInput = ({ item }) => {
  const form = Form.useFormInstance();
  const linkName = uploadLinkFieldName(item.name);
  const link = Form.useWatch(linkName, form);
  const fileList = Form.useWatch(item.name, form);

  const hasFile = Array.isArray(fileList) ? fileList.length > 0 : !!fileList;
  const hasLink = !!String(link || '').trim();

  return (
    <>
      <Form.Item name={linkName} className="!mb-0 !-mt-2">
        <Input
          allowClear
          placeholder={item.linkPlaceholder || `Link ${(item.label || item.placeholder || 'ảnh').toLowerCase()}`}
        />
      </Form.Item>
      {hasFile && hasLink && (
        <Text type="warning" className="!text-[11px]">
          Có cả ảnh tải lên và link — hệ thống sẽ lưu theo link.
        </Text>
      )}
    </>
  );
};

UploadLinkInput.propTypes = {
  item: PropTypes.object.isRequired,
};

const RenderForm = ({
  fields = [],
  form = null,
  rowGutter = [16, 16],
  onFinish,
  className = '',
  rowClass = '',
  loadingSubmit = false,
  footer = null,
  modalWidth,
  onCancel = () => {},
  onValuesChange,
  extraButtons,
}) => {
  const { message } = App.useApp();

  // Form trong modal khá dài: không cuộn tới ô lỗi thì bấm Lưu trông như không có phản hồi gì
  const handleFinishFailed = ({ errorFields }) => {
    const first = errorFields?.[0];
    if (first) message.error(first.errors?.[0] || 'Vui lòng kiểm tra lại các trường bị lỗi');
  };

  return (
    <Form
      onFinish={onFinish}
      onFinishFailed={handleFinishFailed}
      scrollToFirstError={{ behavior: 'smooth', block: 'center' }}
      form={form}
      layout="vertical"
      className={'render-form ' + className}
      onValuesChange={onValuesChange}
    >
      <Row gutter={rowGutter} className={rowClass ?? ''}>
        {fields.map((item, key) => {
          if (item.html || item.type === 'html') {
            return (
              <Col
                span={item.span || 24}
                md={item.md || item.span || 24}
                lg={item.lg || item.md || item.span || 24}
                key={key}
              >
                {item.content}
              </Col>
            );
          }
          if (item.type === 'divider') {
            return (
              <Col span={24} key={key}>
                <Divider orientation="left" className="!m-0 !mt-4">
                  <span className="text-[11px] font-bold text-gray-400 uppercase tracking-widest">{item.label}</span>
                </Divider>
              </Col>
            );
          }
          item.rules =
            item.rules?.map((v) =>
              !v.message && v.required
                ? {
                    ...v,
                    message: `${item.label || item.placeholder || item.labelHidden} không được bỏ trống`,
                  }
                : v
            ) || [];
          return (
            <Col
              className={item.colClass || ''}
              key={key}
              span={item.span || 24}
              md={item.md || item.span || 24}
              lg={item.lg || item.md || item.span || 24}
            >
              {!item.hidden &&
                item.type !== 'group' &&
                (item.type === 'upload-enter-link' ? (
                  <UploadEnterLink
                    label={item.label || item.placeholder}
                    nameForm={item.name}
                    form={form}
                    rules={item.rules}
                    propsInput={item.propsFormItem}
                    item={item}
                    firstName={item.name}
                  />
                ) : (
                  <>
                    <Form.Item
                      {...(propsConfig[item.type] || {})}
                      name={item.name}
                      rules={item.rules}
                      label={item.label || item.placeholder}
                      className={item.className || ''}
                      {...(item.propsFormItem || {})}
                    >
                      <SwitchInputType item={item} />
                    </Form.Item>
                    {item.enterLink &&
                      typeof item.name === 'string' &&
                      (item.type === 'upload' || item.type === 'upload-cdn') && <UploadLinkInput item={item} />}
                  </>
                ))}
              {item.type === 'group' && (
                <GroupForm
                  itemGroup={item}
                  name={item.name}
                  form={form}
                  parentName={item.name}
                  firstName={item.name}
                  modalWidth={modalWidth}
                />
              )}
            </Col>
          );
        })}
      </Row>
      <Row gutter={rowGutter}>
        {footer ? (
          footer
        ) : (
          <Col span={24} className="md:mt-10 mt-1 flex justify-end gap-3">
            {extraButtons}
            <Button htmlType="button" onClick={onCancel} size="large" className="w-32 rounded-xl">
              Huỷ bỏ
            </Button>
            <Button
              loading={loadingSubmit}
              htmlType="submit"
              type="primary"
              size="large"
              className="w-40 rounded-xl bg-blue-600"
            >
              Xác nhận lưu
            </Button>
          </Col>
        )}
      </Row>
    </Form>
  );
};

RenderForm.propTypes = {
  onFinish: PropTypes.func.isRequired,
  form: PropTypes.object,
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
      labelHidden: PropTypes.string,
      propsInput: PropTypes.object,
      propsFormItem: PropTypes.object,
      titleButtonAdd: PropTypes.node,
      titleButtonDelete: PropTypes.node,
      classItem: PropTypes.string,
      filedsList: PropTypes.array,
      lg: PropTypes.number,
      minItem: PropTypes.number,
      maxItem: PropTypes.number,
      html: PropTypes.bool,
      defaultChecked: PropTypes.any,
      content: PropTypes.node,
      options: PropTypes.array,
      label: PropTypes.string,
      labelCheckbox: PropTypes.node,
      labelAfter: PropTypes.string,
      rules: PropTypes.array,
      type: PropTypes.oneOf([
        'input',
        'radio',
        'date',
        'select',
        'textarea',
        'number',
        'password',
        'upload',
        'upload-cdn',
        'upload-button',
        'upload-file',
        'upload-enter-link',
        'checkbox',
        'group',
        'html',
        'range-picker',
        'ckeditor',
        'switch',
        'fetch',
        'divider',
        'transfer',
        'time',
      ]),
      colClass: PropTypes.string,
      rowClass: PropTypes.string,
      className: PropTypes.string,
      rows: PropTypes.number,
      render: PropTypes.func,
      // upload/upload-cdn: hiện thêm ô dán link ảnh bên dưới nút upload
      enterLink: PropTypes.bool,
      linkPlaceholder: PropTypes.string,
    })
  ).isRequired,
  rowGutter: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  className: PropTypes.string,
  rowClass: PropTypes.string,
  loadingSubmit: PropTypes.bool,
  onCancel: PropTypes.func,
  footer: PropTypes.node,
  modalWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onValuesChange: PropTypes.func,
};

export default RenderForm;
